import { transient } from "aurelia-framework";
import { LookupValue } from "../../../../../models/lookups/lookup.models";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { SharedActivityModel } from "../../../../../models/customers/shared-activities.models";
import { EntityTypes } from "@rightship-tech/common-ui/models/basic.models";

@transient()
export class AddSharedDialog {
    public customerId: number;

    public byBusinessUnitId: number;
    public withCustomerId: number;
    public withBusinessUnitId: number;
    public entityEntityId: number;
    public entityTypes: LookupValue[] = [];
    public isActive: boolean = true;
    
    private onAdd: any;
    private onCancel: any;
    private sharedActivityModel: SharedActivityModel;

    constructor (private dialogClientService: DialogClientService) {

    }

    public activate(model: { 
        customerId: number, 
        onAdd: any
        onCancel: any,
        sharedActivityModel: SharedActivityModel
    }): void {
        this.customerId = model.customerId;
        this.onAdd = model.onAdd;
        this.onCancel = model.onCancel;
        this.sharedActivityModel = model.sharedActivityModel;

        if (this.sharedActivityModel) {
            this.byBusinessUnitId = this.sharedActivityModel.sharedByBusinessUnitId;
            this.withCustomerId = this.sharedActivityModel.sharedWithCustomerId;
            this.withBusinessUnitId = this.sharedActivityModel.sharedWithBusinessUnitId;
            this.entityEntityId = this.sharedActivityModel.entityTypeId;
            this.isActive = this.sharedActivityModel.isActive;
        }

        this.entityTypes = [
            <LookupValue>{ id: EntityTypes.Vet, name: 'Vet' },
            <LookupValue>{ id: EntityTypes.GHGVerification, name: 'Environment Verification' },
            <LookupValue>{ id: EntityTypes.FBR, name: 'FBR' },
            <LookupValue>{ id: EntityTypes.TVQ, name: 'Forms' }
        ]
    }

    close() {
        this.dialogClientService.hide();
    }

    submit() {
        return new Promise<void>((resolve, reject) => {
            this.onAdd({
                sharedActivityId: this.sharedActivityModel ?  this.sharedActivityModel.sharedActivityId : null,
                byCustomerId: this.customerId, 
                byBusinessUnitId: this.byBusinessUnitId, 
                withCustomerId: this.withCustomerId,
                withBusinessUnitId: this.withBusinessUnitId,
                entityTypeId: this.entityEntityId,
                isActive: this.isActive
            }).then(() => {
                resolve();
            }, () => {
                reject();
            })
        });
    }

    cancel() {
        this.onCancel();
    }
}
